import { render, staticRenderFns } from "./SuperCollectionLinear.vue?vue&type=template&id=93ed64b8&lang=pug&"
import script from "./SuperCollectionLinear.vue?vue&type=script&lang=js&"
export * from "./SuperCollectionLinear.vue?vue&type=script&lang=js&"
import style0 from "./SuperCollectionLinear.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93ed64b8')) {
      api.createRecord('93ed64b8', component.options)
    } else {
      api.reload('93ed64b8', component.options)
    }
    module.hot.accept("./SuperCollectionLinear.vue?vue&type=template&id=93ed64b8&lang=pug&", function () {
      api.rerender('93ed64b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/pages/SuperCollection/SuperCollectionLinear.vue"
export default component.exports